import React, { useState, useEffect } from 'react'
import {
  useShowController,
  Show,
  useTranslate,
  TabbedShowLayout,
  Tab,
  useNotify,
  TabbedShowLayoutTabs,
} from 'react-admin'
import { Box, Grid, CircularProgress, Menu, MenuItem, Button } from '@mui/material'
import { Add, ExpandMore } from '@mui/icons-material'
import { ModalPassenger } from 'src/components/pages/sales/reservation/logic/modals/ModalPassenger'
import { AirProduct } from 'src/components/pages/sales/reservation/logic/air/AirProduct'
import { HotelProduct } from 'src/components/pages/sales/reservation/logic/hotel/HotelProduct'
import { CarProduct } from 'src/components/pages/sales/reservation/logic/car/CarProduct'
import { TrainSegmentProduct } from 'src/components/pages/sales/reservation/logic/train/TrainSegmentProduct'
import { TrainPassesProduct } from 'src/components/pages/sales/reservation/logic/train/TrainPassesProduct'
import { BillingReservation } from './logic/billing/BillingReservation'
import { PaymentReservation } from './logic/payment/PaymentReservation'
import { TransferProduct } from './logic/transfer/TransferProduct'
import { AssistanceProduct } from './logic/assistance/AssistanceProduct'
import { useRefresh } from 'react-admin'
import { PassengerReservation } from 'src/components/pages/sales/reservation/logic/passenger/PassengerReservation'
import { paxServices } from 'src/services/reservation/pax/pax.service'
import { isDateISO } from 'src/helper/isDateISO'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { LoadingRecordContext } from 'src/components/pages/sales/reservation/context/LoadingRecordContext'
import { CardLoadingProvider } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { GeneralSection } from 'src/components/pages/sales/reservation/logic/common/GeneralSection'
import { OtherProduct } from './logic/other/OtherProduct'
import { productServices } from 'src/services/reservation/product/product.service'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { ChoiceProductModal } from 'src/components/pages/sales/reservation/logic/common/ChoiceProductModal'
import { useAppState } from 'src/components/layouts/layoutTopNav'
import { PERMISSION_LIST, PERMISSION_MENU } from 'src/helper/Permission'
import orderBy from 'lodash/orderBy'
import { ReservationInfoProvider } from './context/ReservationContext'
import {NotificationsList} from './logic/notifications/NotificationsList'
import { notificationServices } from 'src/services/sales/notification/notification.service'
import { SuppliersTab } from './logic/suppliers/SuppliersTab'
import { NotificationProvider } from '../notification/logic/NotificationContext'
import { CommentsProvider } from './logic/common/CommentsContext'
import { AltBillingTab } from './logic/altBilling/AltBillingTab'

export const ReservationShow = (props) => {
  const { updateCustomTitle } = useAppState()
  const {
    isFetching, // boolean that is true while the record is being fetched, and false once the record is fetched
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
    refetch, // function to refetch record
  } = useShowController()

  const translate = useTranslate()
  const refresh = useRefresh()
  const notify = useNotify()
  const [productAir, setProductAir] = useState([])
  const [productHotel, setProductHotel] = useState([])
  const [productCar, setProductCar] = useState([])
  const [productTrainSegment, setProductTrainSegment] = useState([])
  const [productTrainPasses, setProductTrainPasses] = useState([])
  const [productTransfer, setProductTransfer] = useState([])
  const [productAssistance, setProductAssistance] = useState([])
  const [productOther, setProductOther] = useState([])
  const [openPasaggerModal, setOpenPasaggerModal] = useState(false)
  const [addPassangerLoading, setAddPassangerLoading] = useState(false)

  const [availableProducts, setAvailableProducts] = useState([])
  const [anchorEl, setAnchorEl] = useState()
  const [openProductModal, setOpenProductModal] = useState(false)
  const [selectedProduct, setSelectedProduct] = useState()
  const [productsTabs, setProductsTabs] = useState([])
  const [availableProductsLoading, setAvailableProductsLoading] = useState(true)
  const [notifications, setNotifications] = useState([])
  const [loadingNotifications, setLoadingNotifications] = useState(false)
  const [reloadNotifications, setReloadNotifications] = useState(false)
  const [notificationsCalled, setNotificationsCalled] = useState(false)
  const [firstRender, setFirstRender] = useState(true)

  useEffect(() => {
    if (record) {
      if (record?.work_unit_id) getProductsAvaliableByWorkUnit(record)
      setProductAir(orderByDateIn(existProduct(record, 'air_detail')))
      setProductHotel(orderByDateIn(existProduct(record, 'hotel_detail')))
      setProductCar(orderByDateIn(existProduct(record, 'car_detail')))
      setProductTrainSegment(orderByDateIn(existProduct(record, 'train_detail_segment')))
      setProductTrainPasses(orderByDateIn(existProduct(record, 'train_detail_passes')))
      setProductTransfer(orderByDateIn(existProduct(record, 'transfer_detail')))
      setProductAssistance(orderByDateIn(existProduct(record, 'assistance_detail')))
      setProductOther(orderByDateIn(getProductOthers(existProduct(record, 'other_detail'))))
      updateCustomTitle(record.number)
      setFirstRender(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record])

  useEffect(()=>{
    if (record && (!notificationsCalled)) {
      if(hasPermissionFunction('notification', PERMISSION_MENU)){
          getNotifications()
        }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[record])

  useEffect(()=>{
    if(!firstRender){
      if(hasPermissionFunction('notification', PERMISSION_MENU)){
        getNotifications()
      }
    }
  },[reloadNotifications])


  const getNotifications = async () => {
    setLoadingNotifications(true)
    await notificationServices.getNotificationByParam({ reservation:record.number, status:'1|2'}).then(res=>{
      setNotificationsCalled(true)
      setNotifications(res.issues)
    })
    .finally(()=>{
      setLoadingNotifications(false)
    })
  }

  const getProductOthers = (others) => {
    let productOtherAux = []
    others?.forEach((other) => {
      const index = productOtherAux.findIndex((elem) => elem?.product === other?.product.long_name)
      if (index > -1) {
        productOtherAux[index]?.products?.push(other)
      } else {
        productOtherAux.push({
          product: other.product?.long_name,
          products: [other],
          isOther: true,
        })
      }
    })
    return productOtherAux
  }

  const getProductsAvaliableByWorkUnit = async (record) => {
    const { work_unit_id } = record
    try {
      setAvailableProductsLoading(true)
      const products = await productServices.getProductByWorkUnitId(work_unit_id, true)
      setAvailableProducts(products)
    } catch (error) {
      setAvailableProducts([])
      notify('ra.notification.error_loading_products', {
        type: 'error',
      })
    } finally {
      setAvailableProductsLoading(false)
    }
  }

  const onSelectProduct = (value) => {
    setAnchorEl(null)
    setSelectedProduct(value)
    setOpenProductModal(true)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const onClickButtonOpenPasaggerModal = () => {
    setOpenPasaggerModal(true)
  }

  const onClickButtonClosePasaggerModal = () => {
    setOpenPasaggerModal(false)
  }

  const existProduct = (record, product_name) => {
    if (record && record?.items?.length !== 0) {
      return record?.items?.filter((item) => item.product.ref_table_detail === product_name)
    }
    return undefined
  }

  const orderByDateIn = (items = []) => {
  return orderBy(
    items,
    [
      (item) => item.date_in ? new Date(item.date_in).getTime() : 0,
      (item) => item.id
    ],
    ['asc', 'asc']
  )
}

  const addPassanger = async (passanger) => {
    try {
      setAddPassangerLoading(true)
      let date = passanger?.birth_date
      if (isDateISO(date)) {
        date = new Date(date).toISOString().split('T')[0]
      }
      let format_date = {
        ...passanger,
        birth_date: date,
      }
      //remove items prop
      if (format_date && format_date?.items) {
        delete format_date.items
      }

      const response = await paxServices.addPaxToItems(format_date)
      if (response) {
        notify('ra.notification.add_success_passenger', {
          type: 'success',
          messageArgs: { passenger: response?.name },
        })
        return
      }
      notify('ra.notification.add_error_passenger', {
        type: 'error',
      })
    } catch (error) {
      notify('ra.notification.add_error_passenger', {
        type: 'error',
      })
    } finally {
      setAddPassangerLoading(false)
      onClickButtonClosePasaggerModal()
      customAwait([refresh])
    }
  }

  const LoadingProduct = ({ product_name }) => {
    return (
      <Box display={'flex'} alignItems={'center'}>
        <CircularProgress sx={{ marginRight: '5px' }} size={'10px'} />
        {translate(`ra.title.${product_name}`)}
      </Box>
    )
  }

  const isLoadingProduct = (product) => {
    if (product) {
      if (product[0]?.isOther) {
        return !Boolean(product[0].product) || !product[0]?.products?.[0]?.id
      } else {
        if (Array.isArray(product) && product?.length > 0) {
          return Object.keys(product[0])?.length <= 1 || !product[0]?.id
        }
      }
    }

    return false
  }

  const handleCloseProductModal = () => {
    setOpenProductModal(false)
    setSelectedProduct(null)
  }

  const onSubmitProduct = (product, data, isOther) => {
    handleCloseProductModal()
    data.item_id = data.pricing_relation?.[0]?.item_id
    let productsTabsAux = JSON.parse(JSON.stringify(productsTabs))
    const productTabIndex = productsTabsAux.findIndex((elem) => elem.product === product)
    const productTab =
      productTabIndex > -1 ? productsTabsAux[productTabIndex] : { product, products: [], isOther }
    productTab.products = [...productTab.products, data]
    if (productTabIndex > -1) {
      productsTabsAux.splice(productTabIndex, 1, productTab)
    } else {
      productsTabsAux = [...productsTabsAux, productTab]
    }

    setProductsTabs(productsTabsAux)
    refresh()
  }

  return (
    <Show actions={null} className='reservation-show-container'>
      <LoadingRecordContext.Provider value={isFetching}>
        <CardLoadingProvider>
          <ReservationInfoProvider>
            <CommentsProvider>
            <TabbedShowLayout
              record={record}
              className='reservation_tabs'
              tabs={<TabbedShowLayoutTabs variant='scrollable' scrollButtons='auto' />}
            >
              <Tab value='1' label={translate('ra.title.general')} className='general-section'>
                <GeneralSection />
              </Tab>
              <Tab value='2' label={translate('ra.title.passenger')}>
                <ModalPassenger
                  open={openPasaggerModal}
                  handleClose={onClickButtonClosePasaggerModal}
                  item={record?.items || []}
                  titleModal={translate('ra.title.add_passenger')}
                  onSubmit={addPassanger}
                  loadingButton={addPassangerLoading}
                />
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12} lg={12} xl={12}>
                    <PassengerReservation
                      passengers={record?.passengers}
                      onClickButtonOpenPasaggerModal={onClickButtonOpenPasaggerModal}
                      isLoading={isLoading}
                      item={record?.items || []}
                    />
                  </Grid>
                </Grid>
              </Tab>
              {productAir?.length > 0 ? (
                <Tab
                  value='3'
                  label={
                    isLoadingProduct(productAir) ? (
                      <LoadingProduct product_name='aerial' />
                    ) : (
                      `${translate('ra.title.aerial')} (${productAir?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productAir)}
                >
                  <AirProduct reservation={record} air={productAir} />
                </Tab>
              ) : undefined}
              {productHotel?.length > 0 ? (
                <Tab
                  value='4'
                  label={
                    isLoadingProduct(productHotel) ? (
                      <LoadingProduct product_name='hotel' />
                    ) : (
                      `${translate('ra.title.hotel')} (${productHotel?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productHotel)}
                >
                  <HotelProduct reservation={record} hotel={productHotel} />
                </Tab>
              ) : undefined}
              {productCar?.length > 0 ? (
                <Tab
                  value='5'
                  label={
                    isLoadingProduct(productCar) ? (
                      <LoadingProduct product_name='car' />
                    ) : (
                      `${translate('ra.title.car')} (${productCar?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productCar)}
                >
                  <CarProduct reservation={record} car={productCar} />
                </Tab>
              ) : undefined}
              {productTrainSegment?.length > 0 ? (
                <Tab
                  value='6'
                  label={
                    isLoadingProduct(productTrainSegment) ? (
                      <LoadingProduct product_name='train_segment' />
                    ) : (
                      `${translate('ra.title.train_segment')} (${productTrainSegment?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productTrainSegment)}
                >
                  <TrainSegmentProduct reservation={record} train_segment={productTrainSegment} />
                </Tab>
              ) : undefined}
              {productTrainPasses?.length > 0 ? (
                <Tab
                  value='7'
                  label={
                    isLoadingProduct(productTrainPasses) ? (
                      <LoadingProduct product_name='train_passes' />
                    ) : (
                      `${translate('ra.title.train_passes')} (${productTrainPasses?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productTrainPasses)}
                >
                  <TrainPassesProduct reservation={record} train_passes={productTrainPasses} />
                </Tab>
              ) : undefined}
              {productTransfer?.length > 0 ? (
                <Tab
                  value='8'
                  label={
                    isLoadingProduct(productTransfer) ? (
                      <LoadingProduct product_name='transfer' />
                    ) : (
                      `${translate('ra.title.transfer')} (${productTransfer?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productTransfer)}
                >
                  <TransferProduct reservation={record} transfer={productTransfer} />
                </Tab>
              ) : undefined}
              {productAssistance?.length > 0 ? (
                <Tab
                  value='9'
                  label={
                    isLoadingProduct(productAssistance) ? (
                      <LoadingProduct product_name='assistance' />
                    ) : (
                      `${translate('ra.title.assistance')} (${productAssistance?.length})`
                    )
                  }
                  disabled={isLoadingProduct(productAssistance)}
                >
                  <AssistanceProduct reservation={record} assistance={productAssistance} />
                </Tab>
              ) : undefined}
              {productOther?.length > 0 &&
                productOther.map((tab, i) =>
                  tab?.products && tab.products?.length > 0 ? (
                    <Tab
                      key={i}
                      value={`${10 + i}`}
                      label={
                        isLoadingProduct(productOther) ? (
                          <LoadingProduct product_name='others' />
                        ) : (
                          `${tab.product} (${tab.products?.length})`
                        )
                      }
                      disabled={isLoadingProduct(productOther)}
                    >
                      <OtherProduct reservation={record} otherProduct={tab.products} />
                    </Tab>
                  ) : undefined
                )}
              {hasPermissionFunction('payment-entity', 'list') && (
              <Tab value={`${10 + productOther?.length}`} label={translate('ra.title.payment')}>
                <PaymentReservation reservation={record} refetch={refetch} isFetching={isFetching}/>
              </Tab>
              )}

              {hasPermissionFunction('sales', PERMISSION_LIST) && (
                <Tab value={`${11 + productOther?.length}`} label={translate('ra.title.billing')}>
                  <BillingReservation reservation={record} />
                </Tab>
              )}
              {hasPermissionFunction('notification', PERMISSION_MENU) && (
                <Tab value={`${12 + productOther?.length}`} 
                    label={((loadingNotifications || !notifications)?
                    <LoadingProduct product_name={'notification'}/>: (
                      `${translate('ra.title.notification')} (${notifications?.length})`
                    ))}>
                  <NotificationProvider>
                    <NotificationsList 
                      setReloadNotifications={setReloadNotifications}
                      reloadNotifications = {reloadNotifications}
                      record = {record}
                    />
                  </NotificationProvider>
                </Tab>
              )}
              {hasPermissionFunction('supplier-payment-order', 'show') && (
                <Tab value={`${13 + productOther?.length}`} label={translate('ra.title.suppliers')}>
                  <SuppliersTab reservation={record}/>
                </Tab>
              )}
              {hasPermissionFunction('invoice', 'list') && (
                <Tab value={`${14 + productOther?.length}`} label={'Facturación O'}>
                  <AltBillingTab 
                    reservation={record} 
                  />
                </Tab>
              )}
              <HasPermission permission={'add'}>
                <Button
                  disabled={!Boolean(record) || availableProductsLoading}
                  startIcon={
                    availableProductsLoading ? (
                      <CircularProgress sx={{ marginRight: '5px' }} size={'10px'} />
                    ) : (
                      <Add />
                    )
                  }
                  endIcon={<ExpandMore />}
                  onClick={handleOpenMenu}
                >
                  {translate('ra.title.add_product')}
                </Button>
                <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleCloseMenu}>
                  {availableProducts.map(
                    (product, i) =>
                      product.product_relation && (
                        <MenuItem key={i} onClick={() => onSelectProduct(product)}>
                          {product.product_relation.long_name}
                        </MenuItem>
                      )
                  )}
                  {availableProducts?.length === 0 && (
                    <MenuItem disabled>{translate('ra.message.no_options_availble')}</MenuItem>
                  )}
                </Menu>
              </HasPermission>
              {record && (
                <ChoiceProductModal
                  openModal={openProductModal}
                  product={selectedProduct?.product_relation?.ref_table_detail}
                  reservation={record}
                  passengers={record?.passengers || []}
                  selectedWorkUnit={record.work_unit_relation}
                  selectedProduct={selectedProduct}
                  handleCloseProductModal={handleCloseProductModal}
                  onSubmitProduct={onSubmitProduct}
                />
              )}
            </TabbedShowLayout>
            </CommentsProvider>
          </ReservationInfoProvider>
        </CardLoadingProvider>
      </LoadingRecordContext.Provider>
    </Show>
  )
}
